import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoginForm from "../components/Auth/LoginForm";
import "./Home.scss";
import useWakeUpPing from "../hooks/useWakeUpPing";

export default function Home() {
  useWakeUpPing();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="home-page">
      <div className="home-wrapper">
        <div className="home-container breathing-text-wrapper">
          {/* Welcome content placed above the embedded login form */}
          <section className="home-hero">
            <h1>{t(["home.title", "home_title"])}</h1>

            <p className="home-intro">
              <span className="home-intro__line">
                {t(["home.text1", "home_text_1"])}
              </span>
              <span className="home-intro__line">
                {t(["home.text2", "home_text_2"])}
              </span>
            </p>
          </section>

          {/* Login form embedded directly on the landing page */}
          <section className="home-login-section" aria-label="Login section">
            <LoginForm />
          </section>

          {/* Registration keeps its own dedicated route */}
          <div className="home-register-cta">
            <button type="button" onClick={() => navigate("/register")}>
              {t(["auth.registerButton", "btn_register"])}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
